import { Typography, Tooltip } from '@deeptrue-frontend/ui';
import React from 'react';
import styled from 'styled-components/macro';
import ActivationElement from './ActivationElement';
import { useFormatMessage } from 'components/IntlProvider';
import { getTranslation, LocaleType } from '../utils/getTranslations';
import { LabelType } from '../Bar/Bar';

interface Props {
  chartData: DataType;
  locale?: LocaleType;
}

interface DataType {
  data: { label: LabelType | string; value: number }[];
  activationText: LabelType | string;
  activationTooltip: LabelType | string;
  involvementText: LabelType | string;
  involvementTooltip: LabelType | string;
  activatedTooltip: LabelType | string;
  involvedTooltip: LabelType | string;
  neutralTooltip: LabelType | string;
  unclassifiedTooltip: LabelType | string;
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
`;

const ChartWrapper = styled.div`
  width: 50%;
  margin-right: 5.44rem;
`;

const LegendWrapper = styled.div`
  width: 50%;
  margin-top: -4.3rem;
`;

const LegendTitle = styled(Typography)`
  font-size: 1rem;
  line-height: 1.25rem;
  color: #454a54;
  font-weight: 500;
  display: flex;
  align-items: center;
`;

const LegendElement = styled.div`
  margin-bottom: 2.5rem;
`;

const Activation = ({ locale = 'en', chartData }: Props) => {
  const t = useFormatMessage();
  const {
    activationText,
    activationTooltip,
    involvementText,
    involvementTooltip,
    data,
  } = chartData;

  return (
    <Wrapper>
      <ChartWrapper>
        {data.map((element, idx) => {
          const tooltipKey =
            typeof element.label === 'string'
              ? `${element.label.toLowerCase()}Tooltip`
              : `${element.label.en!.toLowerCase()}Tooltip`;
          return (
            <ActivationElement
              label={getTranslation(element.label, locale)}
              value={element.value}
              tooltip={getTranslation(tooltipKey, locale)}
              key={`${element.label}_${idx}`}
            />
          );
        })}
      </ChartWrapper>
      <LegendWrapper>
        <LegendElement>
          <LegendTitle>
            {t('report.activation.legend.activation', 'Activation')}
            <Tooltip text={getTranslation(activationTooltip, locale)} />
          </LegendTitle>
          <Typography color="#454A54" fontWeight={400} fontSize={'0.875rem'}>
            {getTranslation(activationText, locale)}
          </Typography>
        </LegendElement>
        <LegendElement>
          <LegendTitle>
            {t('report.activation.legend.involvement', 'Involvement')}
            <Tooltip text={getTranslation(involvementTooltip, locale)} />
          </LegendTitle>
          <Typography color="#454A54" fontWeight={400} fontSize={'0.875rem'}>
            {getTranslation(involvementText, locale)}
          </Typography>
        </LegendElement>
      </LegendWrapper>
    </Wrapper>
  );
};

export default Activation;
